import { connect } from 'react-redux'
import { withCookies } from 'react-cookie'
import Lister from '../../components/Lister/Lister'
import HookLogicHelper from '../../helpers/HookLogicHelper'
import { contentAreaIds } from '../../config'
import { splitByRelevancy, mergeContentInList } from '../../helpers/ProductHelper'

const mergeAllProducts = (
  products,
  showHookLogic,
  hookLogicProducts,
  contentAreas = [],
  currentPage,
  showInspiration
) => {
  const contentInList = contentAreas.find(area => area?.id === contentAreaIds.ContentInListArea)
  const inspirationCards = contentInList?.attributes?.length && contentInList.attributes
  const productsWithInspiration =
    showInspiration && currentPage === 1 && inspirationCards ? mergeContentInList(products, inspirationCards) : products
  return showHookLogic
    ? splitByRelevancy(HookLogicHelper.mergeProducts(productsWithInspiration, hookLogicProducts))
    : splitByRelevancy(productsWithInspiration)
}

const mapStateToProps = state => ({
  products: mergeAllProducts(
    state.product.products,
    state.hookLogic.show,
    state.hookLogic.products,
    state.cms.data.contentAreas,
    state.product.currentPage,
    state.application.pageType === 'browse' || state.application.pageType === 'canned'
  ),
  contentAreas: state.cms.data.contentAreas,
  seoArea: state.seo.data.seoArea
})

export default connect(mapStateToProps)(withCookies(Lister))
